import GradientButton from "../at_gradient_button";
import messageResource from "../../messageResource";

export default function SelectorPanelWithApplyButtonHelper() {}

/**
 * Creates an object which add Apply button to a selector panel. Panel must be a subclass of AT.GenericSelectorPanel.
 * @param currentClass - a name of a class to extend
 * @returns object
 */
SelectorPanelWithApplyButtonHelper.getApplyButtonExtension = function( currentClass )
{
    return {
        closeButtonLabelKey: "common.apply",
        cancelButtonLabelKey: "common.cancel",
        resetOnHide: true,

        createFooterButtons: function ()
        {
            currentClass.superclass.createFooterButtons.call( this );

            this.cancelButton = new GradientButton({
                text: messageResource.getMessage(this.cancelButtonLabelKey),
                minWidth: 60,
                cls: "greyButton close-button cancel-button"
            });
        },

        getFooterSection: function ()
        {
            var res = currentClass.superclass.getFooterSection.call( this );
            return [this.cancelButton].concat( res );
        }
    };
};


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_selector_panel_with_apply_button_object.js